var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-col', {
    staticClass: "py-10 pa-lg-30",
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "border-top w-100 pt-16 pt-md-18"
  }, [_c('p', {
    staticClass: "page-text-lg font-weight-medium",
    class: _vm.dupont ? 'mb-10 mb-lg-16' : 'mb-20 mb-lg-32'
  }, [_vm._v(" " + _vm._s(_vm.company) + " ")]), _c('v-img', {
    attrs: {
      "src": _vm.src,
      "max-width": _vm.width
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }